"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const logger_1 = require("../../logger");
const errornotifier_1 = require("../../errornotifier");
const base_1 = require("../base");
const opentracing_1 = require("opentracing");
const browserImpl = (apiRoots) => async (_ctx, path, requestData) => {
    const apiRoot = base_1.lookupApiRoot(apiRoots, path);
    const response = await fetch(`${apiRoot}/${path}`, {
        method: "POST",
        body: requestData,
        credentials: "include"
    });
    const body = await response.arrayBuffer();
    return {
        statusCode: response.status,
        body: new Uint8Array(body)
    };
};
const browserContext = (name, config, logger = new logger_1.BrowserLogger()) => {
    logger = logger.with({
        ts: () => new Date().toISOString(),
        origin: name
    });
    const apiRoot = base_1.parseApiRoot(config.CLIENT_API_ROOT);
    // Putting a Noop tracer to unify the behaviour of ServerContext and
    // BrowserContext for convenience.
    //
    // globalTracer will return a Noop tracer by default if there's no
    // tracer installed:
    // https://github.com/opentracing/opentracing-javascript/blob/master/src/global_tracer.ts
    const tracer = opentracing_1.globalTracer();
    const span = tracer.startSpan("browserContext");
    return {
        logger,
        errorNotifier: errornotifier_1.defaultNotifier(name, config, logger),
        prottpImpl: browserImpl(apiRoot),
        config,
        tracing: { tracer, span }
    };
};
exports.browserContext = browserContext;
//# sourceMappingURL=index.js.map